import { render, staticRenderFns } from "./OverallServiceCharges.vue?vue&type=template&id=23c4d128&"
import script from "./OverallServiceCharges.vue?vue&type=script&lang=js&"
export * from "./OverallServiceCharges.vue?vue&type=script&lang=js&"
import style0 from "./OverallServiceCharges.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports